import React, { useState, useEffect, useRef } from 'react';
import { MdPrint, MdKeyboardArrowDown } from 'react-icons/md';
import { Upload } from 'lucide-react';
import apiService from "../../../config";
import { FileText } from 'lucide-react';
import { useSignature } from '../../../DigitalSignature/UseSignatue';
import SignaturePad from '../../../DigitalSignature/SignaturePad';
import { Eye, Loader, CheckCircle, AlertCircle, X } from 'lucide-react';

const HighwayOtherDocuments = ({ onBack, setSubComponent }) => {
  const certificateContentRef = useRef();
  const [loading, setLoading] = useState(true);
  const [regionalInchargeName, setRegionalInchargeName] = useState("");
  const [regionalInchargeDesignation, setRegionalInchargeDesignation] = useState("");
  const [selectedCertificate, setSelectedCertificate] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedProposalId, setSelectedProposalId] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [pdfForSigning, setPdfForSigning] = useState(null);
  const { signDocument } = useSignature();
  const isCertificateSelected = Boolean(selectedCertificate);
  const [uploadedFile, setUploadedFile] = useState(null);
const [existingUploadedDocument, setExistingUploadedDocument] = useState(null);
const [uploadLoading, setUploadLoading] = useState(false);
const [uploadError, setUploadError] = useState(null);
const [uploadSuccess, setUploadSuccess] = useState(false);
const [showDocumentViewer, setShowDocumentViewer] = useState(false);
const [fileUrlToView, setFileUrlToView] = useState('');
const [isPDFToView, setIsPDFToView] = useState(false);
const [fetchingDocument, setFetchingDocument] = useState(false);


  const [formData, setFormData] = useState({
    project_name: '',
    village: '',
    taluka: '',
    district: '',
    proposal_no_name: '',
    amount: '',
    officer1_name: '',
    officer1_designation: '',
    officer2_name: '',
    officer2_designation: '',
    date: new Date().toISOString().split('T')[0],
    place: '',
    financial_certificate_text: '',
    religious_certificate_text: '',
    railway_certificate_text: '',
    public_rights_certificate_text: '',
  });
  const [editMode, setEditMode] = useState({
    description: false,
    benefit: false,
    financial: false,
    religious: false,
    railway: false,
    publicRights: false,
  });


  // Certificate options for dropdown
  const certificateOptions = [
    // { value: 'all', label: 'सर्व प्रमाणपत्रे (All Certificates)' },
    { value: '', label: 'प्रमाणपत्र निवडा' },
    { value: 'no_previous', label: 'पूर्वी भूसंपादन न झाल्याबाबत प्रमाणपत्र' },
    { value: 'not_cancelled', label: 'प्रस्ताव रद्द होणार नसल्याचे प्रमाणपत्र' },
    { value: 'survey_fee', label: 'संयुक्त मोजणी शुल्क शासन जमा करणे बाबत प्रमाणपत्र' },
    { value: 'financial', label: 'निधी उपलब्धता प्रमाणपत्र' },
    { value: 'public_purpose', label: 'सार्वजनिक प्रयोजनाच्या स्वरुपाबाबत विवरण' },
    { value: 'religious', label: 'धार्मिक स्थळांबाबत प्रमाणपत्र' },
    { value: 'railway', label: 'रेल्वे सीमा बाबत प्रमाणपत्र' },
    { value: 'public_rights', label: 'सार्वजनिक मार्गाधिकार प्रमाणपत्र' },
    { value: 'document_upload', label:'इतर दस्तऐवज अपलोड'}
  ];

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        const userData = JSON.parse(localStorage.getItem("userData"));
        const project = JSON.parse(localStorage.getItem("selectedProject"));
        const projectId = project?.id || project?.project_id;
        const proposalId = userData?.default_proposal || userData?.proposal_id;

        // Get officer information from selectedProposal localStorage
        // const storedProposal = JSON.parse(localStorage.getItem('selectedProposal') || '{}');
        // if (storedProposal?.acquisition_regional_incharge_name) {
        //   setRegionalInchargeName(storedProposal.acquisition_regional_incharge_name);
        // }
        // if (storedProposal?.acquisition_regional_incharge_designation) {
        //   setRegionalInchargeDesignation(storedProposal.acquisition_regional_incharge_designation);
        // }

        if (projectId && proposalId) {
          setSelectedProposalId(proposalId);  // ✅ store proposalId here
          const result = await apiService.getProposalById(projectId, proposalId);
          if (result && result?.status === 200) {
            const data = Array.isArray(result.data)
              ? result.data[0]
              : result.data;
            setFormData({
              project_name: project?.project_name || '',
              village: data?.village_name || '',
              taluka: data?.taluka_name || '',
              district: data?.dist_name || '',
              proposal_no_name: data?.section_11_bhusampadan_no || data?.acquisition_proposal_no || '',
              amount: data?.acquisition_area || '',
              officer1_name: data?.acquisition_regional_incharge_name || '',
              officer1_designation: data?.acquisition_regional_incharge_designation || '',
              officer2_name: data?.acquisition_incharge_name || '',
              officer2_designation: data?.acquisition_incharge_designation || '',
              date: data?.acquisition_proposal_date ? new Date(data.acquisition_proposal_date).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
              place: data?.village_name || '',
              project_description: data?.project_description || '',
              project_social_benfit: data?.project_social_benfit || '',
              financial_certificate_text: data?.financial_provision_certificate || '',
              religious_certificate_text: data?.religious_place_certificate || '',
              railway_certificate_text: data?.railway_boundary_certificate || '',
              public_rights_certificate_text: data?.public_right_of_way_certificate || '',
            });
          }
        }
      } catch (error) {
        console.error("Error loading proposal data:", error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  // Fetch existing uploaded document
useEffect(() => {
  const fetchExistingUploadedDocument = async () => {
    if (!selectedProposalId) return;
    
    try {
      setFetchingDocument(true);
      const project = JSON.parse(localStorage.getItem("selectedProject"));
      const projectId = project?.id || project?.project_id;
      
      const response = await apiService.getDocuments(projectId, selectedProposalId, 'OtherDocument');

      if (response.status === 200 && response.data) {
        const docData = Array.isArray(response.data) ? response.data[0] : response.data;

        if (docData.upload_path || docData.document) {
          setExistingUploadedDocument({
            document: docData.upload_path || docData.document,
            document_category: docData.document_category || 'OtherDocument',
            created_at: docData.created_at || new Date().toISOString()
          });
        } else {
          setExistingUploadedDocument(null);
        }
      }
    } catch (error) {
      console.error('Error fetching uploaded document:', error);
      if (!error.message.includes('404')) {
        setUploadError('No Document Uploaded');
      }
      setExistingUploadedDocument(null);
    } finally {
      setFetchingDocument(false);
    }
  };

  if (selectedProposalId) {
    fetchExistingUploadedDocument();
  }
}, [selectedProposalId]);


  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handleUploadedFile = (e) => {
  const file = e.target.files[0];

  if (!file) return;

  // ✅ open uploaded file in signature modal
  setPdfForSigning(file);
  setShowSignaturePad(true);
};


  const handlePrintView = () => {
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      alert('कृपया पॉपअप अनुमती द्या.');
      return;
    }

    const content = certificateContentRef.current.innerHTML;
    const selectedOption = certificateOptions.find(opt => opt.value === selectedCertificate);
    const title = selectedOption ? selectedOption.label : 'प्रस्ताव प्रमाणपत्र';

    const printHTML = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>${title}</title>
  <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;600;700&display=swap" rel="stylesheet">
  <style>
    @page {
      size: A4 portrait;   
      margin-top: 0.19in;
      margin-bottom: 0.25in;
      margin-left: 0.81in;
      margin-right: 0.5in;
    }
    
    body {
      font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
      font-size: 14px;
      line-height: 1.6;
      color: black;
      background: white;
    }
    
    .certificate {
      max-width: none;
      background: white;
      page-break-inside: avoid;
      margin-bottom: 30px;
      padding: 20px;
    }
    
    /* Project and Proposal Header Styles */
    .flex {
      display: flex;
    }
    
    .justify-between {
      justify-content: space-between;
    }
    
    .items-center {
      align-items: center;
    }
    
    .font-semibold {
      font-weight: 600;
    }
    
    .mb-4 {
      margin-bottom: 16px;
    }
    
    .certificate-header {
      text-align: center;
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 10px;
      text-decoration: underline;
    }

    .main-header {
      text-align: center;
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 10px;
    }
    
    .certificate-content {
      text-align: justify;
      line-height: 2;
      margin: 20px 0;
    }
    
    .signature-section {
      display: flex;
      justify-content: space-between;
      margin-top: 40px;
      page-break-inside: avoid;
    }
    
    .signature-block {
      text-align: center;
    }
    
    table {
      width: 100%;
      border-collapse: collapse;
      margin: 20px 0;
    }
    
    td, th {
      border: 1px solid black;
      padding: 8px;
      text-align: left;
    }
    
    .page-break {
      page-break-after: always;
    }
    
    @media print {
      body { -webkit-print-color-adjust: exact; }
      .print-hidden {
        display: none !important;
      }
    }
  </style>
</head>
<body>
  ${content}
  <script>
    window.onload = function() {
      window.focus();
      window.print();
    };
  </script>
</body>
</html>
`;

    printWindow.document.write(printHTML);
    printWindow.document.close();
  };

  const handleEditToggle = (type) => {
    setEditMode((prev) => ({
      ...prev,
      [type]: !prev[type]
    }));
  };

  // Updated handleSave function
  const handleSave = async (certificateType) => {
    try {
      let updatedData = {};

      switch (certificateType) {
        case 'financial_text':
          updatedData = {
            financial_provision_certificate: formData.financial_certificate_text
          };
          break;
        case 'religious_text':
          updatedData = {
            religious_place_certificate: formData.religious_certificate_text
          };
          break;
        case 'railway_text':
          updatedData = {
            railway_boundary_certificate: formData.railway_certificate_text
          };
          break;
        case 'public_rights_text':
          updatedData = {
            public_right_of_way_certificate: formData.public_rights_certificate_text
          };
          break;
        default:
          alert('No valid certificate selected');
          return;
      }

      console.log('Saving data:', updatedData); // Debug log

      const res = await apiService.updateProposalPublish(
        selectedProposalId,
        updatedData
      );

      if (res.ok || res.status === 200) {
        alert('Changes saved!');
      } else {
        alert('Failed to save changes');
        console.error('Response:', res);
      }
    } catch (error) {
      console.error('Save error:', error);
      alert('Failed to save changes');
    }
  }

  const handleTextChange = (type, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [type]: value
    }));
  };
  // Loader display
  if (loading) {
    return (
      <div className="p-6 max-w-7xl mx-auto">
        <div className="flex justify-center items-center h-80">
          <div className="text-center animate-float">
            <div className="inline-flex relative">
              <div className="w-16 h-16 rounded-full border-4 border-slate-700 border-t-transparent animate-spin"></div>
              <div className="w-16 h-16 rounded-full border-4 border-purple-500 border-b-transparent border-r-transparent animate-spin absolute inset-0" style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <FileText className="h-6 w-6 text-purple-400 animate-pulse" />
              </div>
            </div>
            <p className="text-gray-400 mt-4">प्रमाणपत्र लोड करत आहे...</p>
          </div>
        </div>
      </div>
    );
  }

  const renderNoPreviousAcquisitionCertificate = () => (
    <div className="certificate p-6 mb-8">
      <div className="flex justify-between items-center mb-4">
        <div className="font-semibold">{formData.project_name}</div>
        <div className="font-semibold">{formData.proposal_no_name}</div>
      </div>
      <div className="certificate-header text-xl font-bold text-center underline mb-6">
        पूर्वी भूसंपादन न झाल्याबाबत प्रमाणपत्र
      </div>
      <div className="certificate-content text-justify leading-8">
        <p>प्रमाणित करण्यात येते की, <span className="underline-field">{formData.project_name}</span> या प्रकल्पांतर्गत येणाऱ्या मौजे. प्रस्ताव नाव:<span></span> <span className="underline-field">{formData.village}</span> ता.<span className="underline-field">{formData.taluka}</span> जि.<span className="underline-field">{formData.district}</span> येथील भूसंपादित करावयाच्या जमिनीचा प्रत्यक्षात खाजगी वाटाघाटीद्वारे ताबा घेतलेला नाही. तसेच प्रस्तावीत क्षेत्र यापूर्वी इतर कोणत्याही प्रयोजनासाठी/प्रकल्पासाठी संपादीत करण्यात आलेले नाही.
        </p>
      </div>
      <div className="signature-section flex justify-between mt-12">

        <div className="signature-block text-center">
          <div className="underline-field mb-2">({formData.officer2_name})</div>
          <div>{formData.officer2_designation}</div>
        </div>
        <div className="signature-block text-center">
          <div className="underline-field mb-2">({formData.officer1_name})</div>
          <div>{formData.officer1_designation}</div>
        </div>
      </div>
    </div>
  );

  const renderProposalNotCancelledCertificate = () => (
    <div className="certificate p-6 mb-8">
      <div className="flex justify-between items-center mb-4">
        <div className="font-semibold">{formData.project_name}</div>
        <div className="font-semibold">{formData.proposal_no_name}</div>
      </div>
      <div className="certificate-header text-xl font-bold text-center underline mb-6">
        प्रस्ताव रद्द होणार नसल्याचे प्रमाणपत्र
      </div>
      <div className="certificate-content text-justify leading-8">
        <p>
          प्रमाणित करण्यात येते की, <span className="underline-field">{formData.project_name}</span> या प्रकल्पांतर्गत येणाऱ्या मौजे <span className="underline-field">{formData.village}</span> ता.<span className="underline-field">{formData.taluka}</span> जि.<span className="underline-field">{formData.district}</span> येथील <span className="underline-field">{formData.proposal_no_name}</span> भूसंपादन प्रस्ताव या कार्यालयाकडून भविष्यात रद्द होणार नाही.
        </p>
      </div>
      <div className="signature-section flex justify-between mt-12">

        <div className="signature-block text-center">
          <div className="underline-field mb-2">({formData.officer2_name})</div>
          <div>{formData.officer2_designation}</div>
        </div>
        <div className="signature-block text-center">
          <div className="underline-field mb-2">({formData.officer1_name})</div>
          <div>{formData.officer1_designation}</div>
        </div>
      </div>
    </div>
  );

  const renderSurveyFeeCertificate = () => (
    <div className="certificate p-6 mb-8">
      <div className="flex justify-between items-center mb-4">
        <div className="font-semibold">{formData.project_name}</div>
        <div className="font-semibold">{formData.proposal_no_name}</div>
      </div>

      <div className="certificate-header text-xl font-bold text-center underline mb-6">
        संयुक्त मोजणी शुल्क शासन जमा करणे बाबत प्रमाणपत्र
      </div>

      <div className="certificate-content text-justify leading-8">
        <p>
          प्रमाणित करण्यात येते की, <span className="underline-field">{formData.project_name}</span> या प्रकल्पांतर्गत येणाऱ्या मौजे <span className="underline-field">{formData.village}</span> ता.<span className="underline-field">{formData.taluka}</span> जि.<span className="underline-field">{formData.district}</span> येथील <span className="underline-field">{formData.proposal_no_name}</span> भूसंपादन प्रस्तावाच्या अनुषंगाने भूसंपादन करिता संयुक्त मोजणी कामाकरिता शासन निर्णयानुसार व भूमिअभिलेख विभागाने कळविल्यानुसार मोजणी शुल्काची रक्कम या कार्यालयाकडून शासन जमा करण्यात येईल.
        </p>
      </div>

      <div className="signature-section flex justify-between mt-12">
        <div className="signature-block text-center">
          <div className="underline-field mb-2">({formData.officer2_name})</div>
          <div>{formData.officer2_designation}</div>
        </div>
        <div className="signature-block text-center">
          <div className="underline-field mb-2">({formData.officer1_name})</div>
          <div>{formData.officer1_designation}</div>
        </div>
      </div>
    </div>
  );

  const renderFinancialProvisionCertificate = () => (
    <div className="certificate p-6 mb-8">
      <div className="flex justify-between items-center mb-4">
        <div className="font-semibold">{formData.project_name}</div>
        <div className="font-semibold">{formData.proposal_no_name}</div>
      </div>
      <div className="certificate-header text-xl font-bold text-center underline mb-6">
        निधी उपलब्धता प्रमाणपत्र      </div>
      <div className="flex justify-end mt-6 mb-12 gap-4 print-hidden">
        <button
          onClick={() => {
            if (editMode.financial_text) {
              handleSave('financial_text');
              setEditMode({ ...editMode, financial_text: false });
            } else {
              setEditMode({ ...editMode, financial_text: true });
            }
          }}
          className={`px-6 py-2 rounded font-medium transition-colors ${editMode.financial_text
            ? 'bg-green-600 hover:bg-green-700 text-white'
            : 'bg-blue-600 hover:bg-blue-700 text-white'
            }`}
        >
          {editMode.financial_text ? 'Save' : 'Edit'}
        </button>
        {editMode.financial_text && (
          <button
            onClick={() => setEditMode({ ...editMode, financial_text: false })}
            className="px-6 py-2 rounded font-medium bg-red-600 hover:bg-red-700 text-white transition-colors"
          >
            Cancel
          </button>
        )}
      </div>
      <div className="certificate-content text-justify leading-8">
        {editMode.financial_text ? (
          <textarea
            rows={3}
            className="w-full border-2 border-blue-500 rounded p-3 font-sans"
            value={formData.financial_certificate_text ||
              `प्रमाणित करण्यात येते की, ${formData.project_name} या प्रकल्पास शासकीय मान्यता प्राप्त असून शासनाकडून/विभागाकडून सदर प्रकल्पाकरिता रक्कम ${formData.amount}/- ची आर्थिक तरतूद करण्यात आलेली आहे.`}

            onChange={(e) =>
              setFormData({
                ...formData,
                financial_certificate_text: e.target.value,
              })
            }
          />
        ) : (
          <p>
            {formData.financial_certificate_text ||
              `प्रमाणित करण्यात येते की, ${formData.project_name} या प्रकल्पास शासकीय मान्यता प्राप्त असून शासनाकडून/विभागाकडून सदर प्रकल्पाकरिता रक्कम ${formData.amount}/- ची आर्थिक तरतूद करण्यात आलेली आहे.`}
          </p>
        )}
      </div>

      <div className="signature-section flex justify-between mt-12">
        <div className="signature-block text-center">
          <div className="underline-field mb-2">({formData.officer2_name})</div>
          <div>{formData.officer2_designation}</div>
        </div>
        <div className="signature-block text-center">
          <div className="underline-field mb-2">({formData.officer1_name})</div>
          <div>{formData.officer1_designation}</div>
        </div>
      </div>
    </div>
  );

  const renderPublicPurposeDetailsCertificate = () => (
    <div className="certificate p-6 mb-8 text-center">
      <div className="flex justify-between items-center mb-4">
        <div className="font-semibold">{formData.project_name}</div>
        <div className="font-semibold">{formData.proposal_no_name}</div>
      </div>
      <div className="certificate-header text-xl font-bold text-center underline mb-6">
        सार्वजनिक प्रयोजनाच्या स्वरुपाबाबत विवरण
      </div>
      <table className="w-full border-collapse border border-black text-center">
        <thead>
          <tr>
            <th className="border border-black p-3 text-center font-bold">अ.क्र</th>
            <th className="border border-black p-3 text-center font-bold">मुद्दे</th>
            <th className="border border-black p-3 text-center font-bold">तपशील</th>
            <th className="border border-black p-3 text-center font-bold print-hidden">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border border-black p-3 text-center">1</td>
            <td className="border border-black p-3">प्रकल्प नाव </td>
            <td className="border border-black p-3">{formData.project_name}</td>

          </tr>
          <tr>
            <td className="border border-black p-3 text-center">2</td>
            <td className="border border-black p-3">प्रकल्प कार्याचे वर्णन </td>
            <td className="border border-black p-3 whitespace-pre-wrap break-words max-w-md">
              {editMode.description ? (
                <textarea
                  rows={3}
                  className="w-full border rounded p-2"
                  value={formData.project_description}
                  onChange={(e) =>
                    setFormData({ ...formData, project_description: e.target.value })
                  }
                />
              ) : (
                formData.project_description
              )}
            </td>
            <td className="border border-black p-3 text-center print-hidden">
              <button
                onClick={async () => {
                  if (editMode.description) {
                    try {
                      const data = { project_description: formData.project_description };
                      const res = await apiService.updateProposalPublish(
                        selectedProposalId,
                        data
                      );
                      if (res.ok) {
                        alert("Changes Saved!");
                        setEditMode({ ...editMode, description: false });
                      }
                    } catch (err) {
                      console.error(err);
                      alert("Failed to update proposal");
                    }
                  } else {
                    setEditMode({ ...editMode, description: true });
                  }
                }}
                className={`px-4 py-2 rounded font-medium transition-colors ${editMode.description
                  ? "bg-green-600 hover:bg-green-700 text-white"
                  : "bg-blue-600 hover:bg-blue-700 text-white"
                  }`}
              >
                {editMode.description ? "Save" : "Edit"}
              </button>
            </td>
          </tr>

          <tr>
            <td className="border border-black p-3 text-center">3</td>
            <td className="border border-black p-3">समाजाला मिळणारे लाभ</td>
            <td className="border border-black p-3 whitespace-pre-wrap break-words max-w-md">
              {editMode.benefit ? (
                <textarea
                  rows={3}
                  className="w-full border rounded p-2"
                  value={formData.project_social_benfit}
                  onChange={(e) =>
                    setFormData({ ...formData, project_social_benfit: e.target.value })
                  }
                />
              ) : (
                formData.project_social_benfit
              )}
            </td>
            <td className="border border-black p-3 text-center print-hidden">
              <button
                onClick={async () => {
                  if (editMode.benefit) {
                    try {
                      const data = { project_social_benfit: formData.project_social_benfit };
                      const res = await apiService.updateProposalPublish(
                        selectedProposalId,
                        data
                      );
                      if (res.ok) {
                        alert("Changes Saved!");
                        setEditMode({ ...editMode, benefit: false });
                      }
                    } catch (err) {
                      console.error(err);
                      alert("Failed to update proposal");
                    }
                  } else {
                    setEditMode({ ...editMode, benefit: true });
                  }
                }}
                className={`px-4 py-2 rounded font-medium transition-colors ${editMode.benefit
                  ? "bg-green-600 hover:bg-green-700 text-white"
                  : "bg-blue-600 hover:bg-blue-700 text-white"
                  }`}
              >
                {editMode.benefit ? "Save" : "Edit"}
              </button>
            </td>
          </tr>


        </tbody>
      </table>
      <div className="signature-section flex justify-between mt-12">

        <div className="signature-block text-center">
          <div className="underline-field mb-2">({formData.officer2_name})</div>
          <div>{formData.officer2_designation}</div>
        </div>
        <div className="signature-block text-center">
          <div className="underline-field mb-2">({formData.officer1_name})</div>
          <div>{formData.officer1_designation}</div>
        </div>
      </div>
    </div>
  );

  const renderReligiousPlacesCertificate = () => (
    <div className="certificate p-6 mb-8">
      <div className="flex justify-between items-center mb-4">
        <div className="font-semibold">{formData.project_name}</div>
        <div className="font-semibold">{formData.proposal_no_name}</div>
      </div>
      <div className="certificate-header text-xl font-bold text-center underline mb-6">
        धार्मिक स्थळाबाबत प्रमाणपत्र
      </div>
      <div className="flex justify-end mt-6 mb-12 gap-4 print-hidden">
        <button
          onClick={() => {
            if (editMode.religious_text) {
              handleSave('religious_text');
              setEditMode({ ...editMode, religious_text: false });
            } else {
              setEditMode({ ...editMode, religious_text: true });
            }
          }}
          className={`px-6 py-2 rounded font-medium transition-colors ${editMode.religious_text
            ? 'bg-green-600 hover:bg-green-700 text-white'
            : 'bg-blue-600 hover:bg-blue-700 text-white'
            }`}
        >
          {editMode.religious_text ? 'Save' : 'Edit'}
        </button>
        {editMode.religious_text && (
          <button
            onClick={() => setEditMode({ ...editMode, religious_text: false })}
            className="px-6 py-2 rounded font-medium bg-red-600 hover:bg-red-700 text-white transition-colors"
          >
            Cancel
          </button>
        )}
      </div>
      <div className="certificate-content text-justify leading-8">
        {editMode.religious_text ? (
          <textarea
            rows={3}
            className="w-full border-2 border-blue-500 rounded p-3 font-sans"
            value={formData.religious_certificate_text ||
              `प्रमाणित करण्यात येते की,${formData.project_name} या प्रकल्पांतर्गत येणाऱ्या मौजे ${formData.village} ता.${formData.taluka} जि.${formData.district} येथील भूसंपादित करावयाच्या जमिनीवर कोणत्याही प्रकारचे धार्मिक प्रार्थना स्थळे, मंदिरे, कब्रस्थान, स्मशानभूमी किंवा पवित्र स्मारके नाहीत.`}
            onChange={(e) =>
              setFormData({
                ...formData,
                religious_certificate_text: e.target.value,
              })
            }
          />
        ) : (
          <p>
            {formData.religious_certificate_text ||
              `प्रमाणित करण्यात येते की,${formData.project_name} या प्रकल्पांतर्गत येणाऱ्या मौजे ${formData.village} ता.${formData.taluka} जि.${formData.district} येथील भूसंपादित करावयाच्या जमिनीवर कोणत्याही प्रकारचे धार्मिक प्रार्थना स्थळे, मंदिरे, कब्रस्थान, स्मशानभूमी किंवा पवित्र स्मारके नाहीत.`}
          </p>
        )}
      </div>

      <div className="signature-section flex justify-between mt-12">
        <div className="signature-block text-center">
          <div className="underline-field mb-2">({formData.officer2_name})</div>
          <div>{formData.officer2_designation}</div>
        </div>
        <div className="signature-block text-center">
          <div className="underline-field mb-2">({formData.officer1_name})</div>
          <div>{formData.officer1_designation}</div>
        </div>
      </div>
    </div>
  );

  const renderRailwayBoundaryCertificate = () => (
    <div className="certificate p-6 mb-8">
      <div className="flex justify-between items-center mb-4">
        <div className="font-semibold">{formData.project_name}</div>
        <div className="font-semibold">{formData.proposal_no_name}</div>
      </div>
      <div className="certificate-header text-xl font-bold text-center underline mb-6">
        रेल्वे सीमा बाबत प्रमाणपत्र
      </div>
      <div className="flex justify-end mt-6 mb-12 gap-4 print-hidden">
        <button
          onClick={() => {
            if (editMode.railway_text) {
              handleSave('railway_text');
              setEditMode({ ...editMode, railway_text: false });
            } else {
              setEditMode({ ...editMode, railway_text: true });
            }
          }}
          className={`px-6 py-2 rounded font-medium transition-colors ${editMode.railway_text
            ? 'bg-green-600 hover:bg-green-700 text-white'
            : 'bg-blue-600 hover:bg-blue-700 text-white'
            }`}
        >
          {editMode.railway_text ? 'Save' : 'Edit'}
        </button>
        {editMode.railway_text && (
          <button
            onClick={() => setEditMode({ ...editMode, railway_text: false })}
            className="px-6 py-2 rounded font-medium bg-red-600 hover:bg-red-700 text-white transition-colors"
          >
            Cancel
          </button>
        )}
      </div>
      <div className="certificate-content text-justify leading-8">
        {editMode.railway_text ? (
          <textarea
            rows={3}
            className="w-full border-2 border-blue-500 rounded p-3 font-sans"
            value={formData.railway_certificate_text ||
              `प्रमाणित करण्यात येते की,${formData.project_name} या प्रकल्पांतर्गत येणाऱ्या मौजे ${formData.village} ता.${formData.taluka} जि.${formData.district} येथील भूसंपादित करावयाच्या जमिनी रेल्वे सीमांच्या जवळ आहे/नाही. रेल्वे सीमांच्या जवळ असल्यास रेल्वे सीमेपासून अंतर किमी आहे.`}
            onChange={(e) =>
              setFormData({
                ...formData,
                railway_certificate_text: e.target.value,
              })
            }
          />
        ) : (
          <p>
            {formData.railway_certificate_text ||
              `प्रमाणित करण्यात येते की,${formData.project_name} या प्रकल्पांतर्गत येणाऱ्या मौजे ${formData.village} ता.${formData.taluka} जि.${formData.district} येथील भूसंपादित करावयाच्या जमिनी रेल्वे सीमांच्या जवळ आहे/नाही. रेल्वे सीमांच्या जवळ असल्यास रेल्वे सीमेपासून अंतर किमी आहे.`}
          </p>
        )}
      </div>

      <div className="signature-section flex justify-between mt-12">
        <div className="signature-block text-center">
          <div className="underline-field mb-2">({formData.officer2_name})</div>
          <div>{formData.officer2_designation}</div>
        </div>
        <div className="signature-block text-center">
          <div className="underline-field mb-2">({formData.officer1_name})</div>
          <div>{formData.officer1_designation}</div>
        </div>
      </div>
    </div>
  );

  const renderPublicRightsOfWayCertificate = () => (
    <div className="certificate p-6 mb-8">
      <div className="flex justify-between items-center mb-4">
        <div className="font-semibold">{formData.project_name}</div>
        <div className="font-semibold">{formData.proposal_no_name}</div>
      </div>
      <div className="certificate-header text-xl font-bold text-center underline mb-6">
        सार्वजनिक मार्गाधिकार प्रमाणपत्र
      </div>
      <div className="flex justify-end mt-6 mb-12 gap-4 print-hidden">
        <button
          onClick={() => {
            if (editMode.public_rights_text) {
              handleSave('public_rights_text');
              setEditMode({ ...editMode, public_rights_text: false });
            } else {
              setEditMode({ ...editMode, public_rights_text: true });
            }
          }}
          className={`px-6 py-2 rounded font-medium transition-colors ${editMode.public_rights_text
            ? 'bg-green-600 hover:bg-green-700 text-white'
            : 'bg-blue-600 hover:bg-blue-700 text-white'
            }`}
        >
          {editMode.public_rights_text ? 'Save' : 'Edit'}
        </button>
        {editMode.public_rights_text && (
          <button
            onClick={() => setEditMode({ ...editMode, public_rights_text: false })}
            className="px-6 py-2 rounded font-medium bg-red-600 hover:bg-red-700 text-white transition-colors"
          >
            Cancel
          </button>
        )}
      </div>
      <div className="certificate-content text-justify leading-8">
        {editMode.public_rights_text ? (
          <textarea
            rows={3}
            className="w-full border-2 border-blue-500 rounded p-3 font-sans"
            value={formData.public_rights_certificate_text ||
              `प्रमाणित करण्यात येते की,${formData.project_name} अंतर्गत येणाऱ्या मौजे ${formData.village} ता.${formData.taluka} जि.${formData.district} येथील भूसंपादित करावयाच्या क्षेत्रातून कोणताही सार्वजनिक मार्गाधिकार, जलप्रवाह, जलवाहिनी किंवा जलनि:सारण मार्ग जात आहे/नाही.`}
            onChange={(e) =>
              setFormData({
                ...formData,
                public_rights_certificate_text: e.target.value,
              })
            }
          />
        ) : (
          <p>
            {formData.public_rights_certificate_text ||
              `प्रमाणित करण्यात येते की,${formData.project_name} अंतर्गत येणाऱ्या मौजे ${formData.village} ता.${formData.taluka} जि.${formData.district} येथील भूसंपादित करावयाच्या क्षेत्रातून कोणताही सार्वजनिक मार्गाधिकार, जलप्रवाह, जलवाहिनी किंवा जलनि:सारण मार्ग जात आहे/नाही.`}
          </p>
        )}
      </div>

      <div className="signature-section flex justify-between mt-12">
        <div className="signature-block text-center">
          <div className="underline-field mb-2">({formData.officer1_name})</div>
          <div>{formData.officer1_designation}</div>
        </div>
        <div className="signature-block text-center">
          <div className="underline-field mb-2">({formData.officer2_name})</div>
          <div>{formData.officer2_designation}</div>
        </div>
      </div>
    </div>
  );

  const renderUploadDocument = () => {
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      const validTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
      if (!validTypes.includes(file.type)) {
        setUploadError('कृपया फक्त PDF किंवा Image फाइल निवडा');
        return;
      }
      
      // Validate file size (max 10MB)
      if (file.size > 10 * 1024 * 1024) {
        setUploadError('फाइल साइज 10MB पेक्षा कमी असावी');
        return;
      }
      
      setUploadedFile(file);
      setUploadError(null);
    }
  };

  const handleUploadSubmit = async () => {
    if (!uploadedFile) {
      setUploadError('कृपया फाइल निवडा');
      return;
    }

    if (!selectedProposalId) {
      setUploadError('प्रकल्प किंवा प्रस्ताव ID उपलब्ध नाही');
      return;
    }

    try {
      setUploadLoading(true);
      setUploadError(null);
      setUploadSuccess(false);

      const project = JSON.parse(localStorage.getItem("selectedProject"));
      const projectId = project?.id || project?.project_id;

      const formData = new FormData();
      formData.append('type', 'OtherDocument');
      formData.append('project_id', projectId);
      formData.append('proposal_id', selectedProposalId);
      formData.append('document', uploadedFile);

      const result = await apiService.postAddUpdateOtherDocuments(formData);
      console.log('Upload response:', result);

      const isSuccess =
        !result ||
        result.status === 200 ||
        result.status === 201 ||
        result.status === 'success' ||
        result.success === true ||
        result.data?.success === true ||
        result.data?.status === 200 ||
        result.data?.status === 201 ||
        result.message?.toLowerCase()?.includes('success') ||
        result.data?.message?.toLowerCase()?.includes('success') ||
        result.documents?.document;

      if (isSuccess) {
        setUploadSuccess(true);
        setUploadError(null);
        setUploadedFile(null);

        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) fileInput.value = '';

        // Fetch updated existing document
        const response = await apiService.getDocuments(projectId, selectedProposalId, 'OtherDocument');
        if (response.status === 200 && response.data) {
          const docData = Array.isArray(response.data) ? response.data[0] : response.data;
          if (docData.upload_path || docData.document) {
            setExistingUploadedDocument({
              document: docData.upload_path || docData.document,
              document_category: docData.document_category || 'OtherDocument',
              created_at: docData.created_at || new Date().toISOString()
            });
          }
        }

        setTimeout(() => setUploadSuccess(false), 4000);
      } else {
        console.warn('Unexpected upload response:', result);
        setUploadError(result?.message || 'डॉक्युमेंट अपलोड करताना त्रुटी');
      }
    } catch (err) {
      console.error('Upload error:', err);
      const errorStatus = err.response?.status;
      const errorData = err.response?.data;

      const isStillSuccess =
        errorStatus === 200 ||
        errorStatus === 201 ||
        errorData?.status === 200 ||
        errorData?.status === 201 ||
        errorData?.message?.toLowerCase()?.includes('success');

      if (isStillSuccess) {
        setUploadSuccess(true);
        setUploadError(null);
        setUploadedFile(null);

        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) fileInput.value = '';

        // Fetch updated existing document
        const project = JSON.parse(localStorage.getItem("selectedProject"));
        const projectId = project?.id || project?.project_id;
        
        const response = await apiService.getDocuments(projectId, selectedProposalId, 'OtherDocument');
        if (response.status === 200 && response.data) {
          const docData = Array.isArray(response.data) ? response.data[0] : response.data;
          if (docData.upload_path || docData.document) {
            setExistingUploadedDocument({
              document: docData.upload_path || docData.document,
              document_category: docData.document_category || 'OtherDocument',
              created_at: docData.created_at || new Date().toISOString()
            });
          }
        }

        setTimeout(() => setUploadSuccess(false), 4000);
      } else {
        setUploadError('डॉक्युमेंट अपलोड करताना त्रुटी');
      }
    } finally {
      setUploadLoading(false);
    }
  };

  const handleViewDocument = (urlOrFile) => {
    if (!urlOrFile) return;

    let url;
    let isPdf;

    if (urlOrFile instanceof File) {
      url = URL.createObjectURL(urlOrFile);
      isPdf = urlOrFile.type === 'application/pdf';
    } else {
      url = urlOrFile;
      isPdf = urlOrFile.toLowerCase().includes('.pdf');
    }

    setFileUrlToView(url);
    setIsPDFToView(isPdf);
    setShowDocumentViewer(true);
  };

  const closeDocumentViewer = () => {
    setShowDocumentViewer(false);
    if (fileUrlToView.startsWith('blob:')) {
      URL.revokeObjectURL(fileUrlToView);
    }
    setFileUrlToView('');
    setIsPDFToView(false);
  };

  if (fetchingDocument) {
    return (
      <div className="certificate p-6 mb-8">
        <div className="flex justify-center items-center h-40">
          <div className="text-center">
            <Loader className="w-8 h-8 animate-spin text-blue-500 mx-auto mb-2" />
            <p className="text-gray-600">लोड करत आहे...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="certificate p-6 mb-8">

      {/* Heading */}
      <h2 className="text-xl font-semibold mb-6 text-gray-800 border-b pb-3">
        इतर दस्तऐवज अपलोड
      </h2>

      {/* Success Message */}
      {uploadSuccess && (
        <div className="mb-4 p-4 rounded-lg bg-green-50 border border-green-200 print-hidden">
          <div className="flex items-center text-green-800">
            <CheckCircle className="w-5 h-5 mr-3" />
            <span className="font-medium">डॉक्युमेंट यशस्वीरित्या अपलोड झाले!</span>
          </div>
        </div>
      )}

      {/* Error Message */}
      {uploadError && (
        <div className="mb-4 p-4 rounded-lg bg-red-50 border border-red-200 print-hidden">
          <div className="flex items-center justify-between">
            <div className="flex items-center text-red-800">
              <AlertCircle className="w-5 h-5 mr-3" />
              <span className="font-medium">{uploadError}</span>
            </div>
            <button onClick={() => setUploadError(null)} className="text-red-600 hover:text-red-800">
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}

      {/* File Upload Section */}
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            नवीन डॉक्युमेंट निवडा
          </label>
          <input
            type="file"
            accept="application/pdf,image/jpeg,image/jpg,image/png"
            onChange={handleFileChange}
            className="block w-full text-sm text-gray-600 
                     file:mr-4 file:py-2 file:px-4 
                     file:rounded-lg file:border-0 
                     file:text-sm file:font-semibold 
                     file:bg-indigo-600 file:text-white 
                     hover:file:bg-indigo-700
                     border border-gray-300 rounded-lg
                     cursor-pointer print-hidden"
          />
          {uploadedFile && (
            <p className="mt-2 text-sm text-green-600">
              निवडलेली फाइल: {uploadedFile.name}
            </p>
          )}
        </div>

        {/* Action Buttons */}
        <div className="flex gap-3 print-hidden">
          {uploadedFile && (
            <>
              <button
                onClick={() => handleViewDocument(uploadedFile)}
                className="flex items-center gap-2 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
              >
                <Eye className="w-4 h-4" />
                पूर्वावलोकन
              </button>
              
              <button
                onClick={handleUploadSubmit}
                disabled={uploadLoading}
                className={`flex items-center gap-2 px-6 py-2 rounded-lg text-white transition-colors ${
                  uploadLoading 
                    ? 'bg-green-400 cursor-not-allowed' 
                    : 'bg-green-600 hover:bg-green-700'
                }`}
              >
                {uploadLoading ? (
                  <>
                    <Loader className="w-4 h-4 animate-spin" />
                    अपलोड करत आहे...
                  </>
                ) : (
                  <>
                    <Upload className="w-4 h-4" />
                    सबमिट करा
                  </>
                )}
              </button>
            </>
          )}
        </div>
      </div>

      {/* Existing Document Section */}
      {existingUploadedDocument && (
        <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <FileText className="w-5 h-5 text-blue-600 mr-3" />
              <div>
                <p className="font-medium text-gray-800">सध्याचे डॉक्युमेंट</p>
                <p className="text-sm text-gray-600">अपलोड दिनांक: {new Date(existingUploadedDocument.created_at || Date.now()).toLocaleDateString('en-GB')}</p>
              </div>
            </div>
            <button
              onClick={() => handleViewDocument(existingUploadedDocument.document)}
              className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              <Eye className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}

      {/* Document Viewer Modal */}
      {showDocumentViewer && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-3xl w-full max-w-6xl h-[95vh] shadow-2xl overflow-hidden border border-gray-200">
            {/* Header */}
            <div className="flex justify-between items-center p-4 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50">
              <div className="flex items-center space-x-3">
                <h3 className="text-2xl font-bold text-gray-800 tracking-tight">
                  डॉक्युमेंट पूर्वावलोकन
                </h3>
              </div>
              <button
                onClick={closeDocumentViewer}
                className="w-10 h-10 rounded-full bg-gray-100 hover:bg-red-100 text-gray-500 hover:text-red-500 transition-all duration-200 flex items-center justify-center text-xl font-bold shadow-sm hover:shadow-md"
                aria-label="Close modal"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            {/* Document Viewer Container */}
            <div className="h-[calc(95vh-80px)] flex flex-col">
              <div className="flex-1 bg-gray-50 overflow-hidden shadow-inner border border-gray-200">
                <div className="w-full h-full flex items-center justify-center">
                  {isPDFToView ? (
                    <iframe
                      src={fileUrlToView}
                      className="w-full h-full border-0 bg-white shadow-lg"
                      title="PDF Preview"
                    />
                  ) : (
                    <img
                      src={fileUrlToView}
                      alt="Document"
                      className="max-w-full max-h-full object-contain shadow-lg"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

  const renderSelectedCertificate = () => {
    const baseStyle = { fontFamily: "'Noto Sans Devanagari', Arial, sans-serif" };

    switch (selectedCertificate) {
      case 'no_previous':
        return <div className="space-y-8 bg-white p-8" style={baseStyle}>{renderNoPreviousAcquisitionCertificate()}</div>;
      case 'not_cancelled':
        return <div className="space-y-8 bg-white p-8" style={baseStyle}>{renderProposalNotCancelledCertificate()}</div>;
      case 'survey_fee':
        return <div className="space-y-8 bg-white p-8" style={baseStyle}>{renderSurveyFeeCertificate()}</div>;
      case 'financial':
        return <div className="space-y-8 bg-white p-8" style={baseStyle}>{renderFinancialProvisionCertificate()}</div>;
      case 'public_purpose':
        return <div className="space-y-8 bg-white p-8" style={baseStyle}>{renderPublicPurposeDetailsCertificate()}</div>;
      case 'religious':
        return <div className="space-y-8 bg-white p-8" style={baseStyle}>{renderReligiousPlacesCertificate()}</div>;
      case 'railway':
        return <div className="space-y-8 bg-white p-8" style={baseStyle}>{renderRailwayBoundaryCertificate()}</div>;
      case 'public_rights':
        return <div className="space-y-8 bg-white p-8" style={baseStyle}>{renderPublicRightsOfWayCertificate()}</div>;
      case 'document_upload':
        return <div className="space-y-8 bg-white p-8" style={baseStyle}>{renderUploadDocument()}</div>;
      default:
        return <div className="p-8 text-center text-gray-500">प्रमाणपत्र निवडा</div>;
    }
  };


  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50 p-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8 border border-gray-200">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
            <div>
              <h1 className="text-3xl font-bold text-gray-800 mb-2">प्रस्ताव प्रमाणपत्र</h1>
              <p className="text-gray-600">Proposal Certificate</p>
            </div>

            <div className="flex flex-wrap gap-3 items-center">
              {/* Certificate Selection Dropdown */}
              <div className="relative">
                <button
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  className="flex items-center space-x-2 px-4 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-300 shadow-lg hover:shadow-blue-200 min-w-[280px] justify-between"
                >
                  <span className="text-sm">
                    {certificateOptions.find(opt => opt.value === selectedCertificate)?.label || 'प्रमाणपत्र निवडा'}
                  </span>
                  <MdKeyboardArrowDown
                    size={20}
                    className={`transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}
                  />
                </button>

                {dropdownOpen && (
                  <div className="absolute top-full left-0 mt-2 w-full bg-white border border-gray-200 rounded-xl shadow-xl z-50 max-h-80 overflow-y-auto">
                    {certificateOptions.map((option) => (
                      <button
                        key={option.value}
                        onClick={() => {
                          setSelectedCertificate(option.value);
                          setDropdownOpen(false);
                        }}
                        className={`w-full text-left px-4 py-3 hover:bg-blue-50 transition-colors duration-200 text-sm border-b border-gray-100 last:border-b-0 first:rounded-t-xl last:rounded-b-xl ${selectedCertificate === option.value ? 'bg-blue-100 text-blue-700' : 'text-gray-700'
                          }`}
                      >
                        {option.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>

            <button className="relative" disabled={!isCertificateSelected}>
              <label
                className={`flex items-center space-x-2 px-4 py-2 rounded-md cursor-pointer
                  ${!isCertificateSelected
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-yellow-600 hover:bg-yellow-700 text-white'
                  }`}
              >
                <Upload size={18} />
                <span>Upload Signature</span>

                <input
                  type="file"
                  accept="application/pdf,image/*"
                  className="hidden"
                  disabled={!isCertificateSelected}
                  onChange={handleUploadedFile}
                />
              </label>
            </button>


              <button
                onClick={handlePrintView}
                disabled={!isCertificateSelected}
                className={`flex items-center space-x-2 px-6 py-3 rounded-xl transition-all duration-300 shadow-lg
                  ${!isCertificateSelected
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white'
                  }`}
              >
                <MdPrint size={20} />
                <span>प्रिंट करा</span>
              </button>

            </div>
          </div>
        </div>

        {/* Certificate Document */}
        <div className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden">
          <div ref={certificateContentRef}>
            {renderSelectedCertificate()}
          </div>
        </div>

        {/* Click outside to close dropdown */}
        {dropdownOpen && (
          <div
            className="fixed inset-0 z-40"
            onClick={() => setDropdownOpen(false)}
          ></div>
        )}
      </div>
      {showSignaturePad && pdfForSigning && (
  <SignaturePad
    pdfFile={pdfForSigning}
    onSign={(signaturesArray) => {
      setShowSignaturePad(false);

      signDocument(pdfForSigning, signaturesArray).then(async (signedPdf) => {
        const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
        const projectId = selectedProject?.id || selectedProject?.project_id;
        const proposalId = localStorage.getItem("currentProposalId");

        await apiService.postAddSignaturePDF(
          projectId,
          proposalId,
          "parishisht1",
          signedPdf
        );

        const sectionRes = await apiService.getSectionFile(
          projectId,
          proposalId,
          "parishisht1"
        );

        if (sectionRes?.isSignAvailable) {
          setPreviewUrl(sectionRes.data[0].file_path);
        }

        setPdfForSigning(null);
      });
    }}
    onCancel={() => {
      setShowSignaturePad(false);
      setPdfForSigning(null);
    }}
  />
)}
    </div>
  );
};

export default HighwayOtherDocuments;